export default {
  // Page title
  title: "Push Statistics",
  
  // Search form
  searchForm: {
    pushTime: "Push Time",
    pushTimePlaceholder: "Please select time range",
    memberAccount: "Push Member",
    memberAccountPlaceholder: "Please enter",
    pushType: "Push Type",
    pushTypePlaceholder: "Please select",
    search: "Query",
    reset: "Reset"
  },
  
  // Table column titles
  table: {
    memberAccount: "Push Member",
    pushType: "Push Type",
    subPushType: "Sub Type",
    pushTitle: "Push Title",
    pushContent: "Push Content",
    pushTime: "Push Time",
    status: "Status",
    createTime: "Create Time"
  },
  
  // Fields
  pushName: "Message Name",
  pushType: "Push Type",
  subPushType: "Sub Type",
  pushTime: "Push Time",
  memberType: "Member Type",
  memberTypePlaceholder: "Please select",
  createTime: "Operation Time",
  createUserName: "Operator",
  sendUserCount: "Send User Count",
  pushSuccessToFailed: "Push Total/Arrived",
  pushOpenCount: "Push Open Count",
  pushOpenRate: "Push Open Rate",
  pleaseEnter: "Please enter"
};
